export default {
  privateKey: 'MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAJOACGU2GtO588XyVGIYuqB+pEfNSNiqu6NjLpnGfCLWBfZKMLCyLUS1Lkl8a6MsA1+wS/DR1Mklh8nnh1HEytzAJSoHp+J5So5gKlaTxNJzpL/oI0Q466qQFxfh23FOHffFzx4rMe98QXpOCrpFWTXjPp907bLVzQARQ3k0lhQ5AgMBAAECgYBKMTuH1Wg3GbDh35vMYA33ztvJdhvvSCnr7GazWOB2EVucYAMPzf/xMIVg12G5CNmFl0MLljBHIUalK32ohqlXDw1sQbIDTjV1UOVefcW2aNw96g10RvooPdLUlzErHHs2yMP6PkPUSh9+IJyNNz++quTfNHA9Vh4tU073/RAs0QJBAMd4PQDoAWGb7rPNuc59f1UlueLMxA0kO3o/9yAO7e6FOMIet8O5qZXMdT1MXQcPoSN3WdvKJ0AKZTvkZOMe9iUCQQC9TVeEnZ/Ptd16h+9R8mtt73VtSccXw17myWcNkGNNp7V0cVdwBPhAD4y7u9d4kfWFj8rJiC0oX+3Qr7OkMXeFAkBQG6nkQ0jKuqUS8Pw+QYhx2cTdoP7biEGaxzWoWlaUBEzXKR8EK/w/fO1YwOJbg5tjcvtTmcxJm+MsOn2J+VVBAkACVXnGwMq/nNZmNFbXA84fRNyFxGsX9+irn8ANgsI2quKp1NvnHaiR4Z8ykVZOvj3wr50obu1fmg8si34DgDihAkAousexchiGe8pR3ve6qCLp29H6NjE5n3oIN9p6G6fJtrAnjoiO1STveC2/95kQfzDNSLOtVNQC0T5+qP3F2XXL',
  spinning: false,
  contentType: 'application/x-www-form-urlencoded',
  token: '',
  pwdFlag: 0,
  pages: [],
  currentPath: '',
  docClickEleClass: '',
  menuLevel: [],
  naviKey: '',
  naviSubKey: '',
  naviItems: [],
  industryOptions: [],
  moduleOptions: [],
  classifyOptions: [],
  optionsFetched: false,
  providerList: [],
  enable: true,
  auditorOptions: [],
  allIndustryOpton: [],
};
